import {
  LOAD_FAULTS_UPLOAD_PENDING,
  LOAD_FAULTS_UPLOAD_FULFILLED,
  LOAD_FAULTS_UPLOAD_REJECTED,
  LOAD_NEW_FAULTS_UPLOAD_PENDING,
  LOAD_NEW_FAULTS_UPLOAD_FULFILLED,
  LOAD_NEW_FAULTS_UPLOAD_REJECTED,
  LOAD_FAULT_DETAILS_PENDING,
  LOAD_FAULT_DETAILS_FULFILLED,
  LOAD_FAULT_DETAILS_REJECTED,
  LOAD_FAULT_USER_GROUPS_PENDING,
  LOAD_FAULT_USER_GROUPS_FULFILLED,
  LOAD_FAULT_USER_GROUPS_REJECTED,
  POST_FAULT_PENDING,
  POST_FAULT_FULFILLED,
  POST_FAULT_REJECTED,
  PUT_FAULT_PENDING,
  PUT_FAULT_FULFILLED,
  PUT_FAULT_REJECTED,
  PATCH_FAULT_DEFINITION_PENDING,
  PATCH_FAULT_DEFINITION_FULFILLED,
  PATCH_FAULT_DEFINITION_REJECTED,
  POST_FAULT_DEFINITION_PENDING,
  POST_FAULT_DEFINITION_FULFILLED,
  POST_FAULT_DEFINITION_REJECTED,
  DELETE_FAULT_PENDING,
  DELETE_FAULT_FULFILLED,
  DELETE_FAULT_REJECTED,
  DELETE_FAULT_DEFINITION_PENDING,
  DELETE_FAULT_DEFINITION_FULFILLED,
  DELETE_FAULT_DEFINITION_REJECTED,
  CLEAR_TROUBLESHOOTING_MESSAGES,
  CLEAR_FAULT_DETAILS,
} from '../actions/troubleshooting'
import i18n from 'i18next'

export default function troubleshooting(state = {}, action) {
  switch (action.type) {
    case LOAD_FAULTS_UPLOAD_PENDING:
    case LOAD_NEW_FAULTS_UPLOAD_PENDING:
    case LOAD_FAULT_DETAILS_PENDING:
    case LOAD_FAULT_USER_GROUPS_PENDING:
    case POST_FAULT_PENDING:
    case PUT_FAULT_PENDING:
    case PATCH_FAULT_DEFINITION_PENDING:
    case POST_FAULT_DEFINITION_PENDING:
    case DELETE_FAULT_PENDING:
    case DELETE_FAULT_DEFINITION_PENDING:
      return {
        ...state,
        isLoading: true,
        successMessage: null,
        errorMessage: null,
      }
    case LOAD_FAULTS_UPLOAD_REJECTED:
    case LOAD_NEW_FAULTS_UPLOAD_REJECTED:
    case LOAD_FAULT_DETAILS_REJECTED:
    case LOAD_FAULT_USER_GROUPS_REJECTED:
    case POST_FAULT_REJECTED:
    case PUT_FAULT_REJECTED:
    case PATCH_FAULT_DEFINITION_REJECTED:
    case POST_FAULT_DEFINITION_REJECTED:
    case DELETE_FAULT_REJECTED:
    case DELETE_FAULT_DEFINITION_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_FAULTS_UPLOAD_FULFILLED:
      const faultsUpload = state?.faultsUpload || []
      const newFaultsUploadIds = action.payload.data?.map((item) => item.id)
      const faultsUploadDifference = faultsUpload.filter((x) => !newFaultsUploadIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        faultsUpload: faultsUploadDifference,
        canLoadMoreFaultsUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_FAULTS_UPLOAD_FULFILLED:
      return {
        ...state,
        faultsUpload: action.payload.data,
        canLoadMoreFaultsUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_FAULT_DETAILS_FULFILLED:
      return {
        ...state,
        faultDetails: action.payload,
        isLoading: false,
      }
    case LOAD_FAULT_USER_GROUPS_FULFILLED:
      return {
        ...state,
        faultUserGroups: action.payload,
        isLoading: false,
      }
    case POST_FAULT_FULFILLED:
      const existingFaultsUpload = state?.faultsUpload || []

      const uniqueLanguagesSet = new Set(action.payload.definitions?.map((item) => item.languageCode))

      const mappedFault = {
        id: action.payload.id,
        fault: action.payload.fault,
        videos: action.payload.videos || [],
        models: action.payload.models || [],
        descriptions: action.payload.definitions[0]?.descriptions || [],
        languageCodes: Array.from(uniqueLanguagesSet),
      }

      return {
        ...state,
        faultsUpload: [mappedFault, ...existingFaultsUpload],
        isLoading: false,
        successMessage: i18n.t('troubleshoot.fault_created_successfully'),
      }
    case PUT_FAULT_FULFILLED:
      const updatedUniqueLanguagesSet = new Set(action.payload.definitions?.map((item) => item.languageCode))

      const updatedMappedFault = {
        id: action.payload.id,
        fault: action.payload.fault,
        videos: action.payload.videos || [],
        models: action.payload.models || [],
        isActive: action.payload.isActive,
        descriptions: action.payload.definitions[0]?.descriptions || [],
        languageCodes: Array.from(updatedUniqueLanguagesSet),
      }

      const updatedFaultsUpload = state?.faultsUpload.map((item) => (item.id === action.payload.id ? updatedMappedFault : item))

      return {
        ...state,
        faultsUpload: updatedFaultsUpload,
        isLoading: false,
        successMessage: i18n.t('troubleshoot.fault_updated_successfully'),
      }
    case PATCH_FAULT_DEFINITION_FULFILLED:
      const updatedDefinition = Array.isArray(action.payload) ? action.payload[0] : action.payload

      const updatedFaultUpload = state.faultsUpload.map((fault) => {
        if (fault.id !== updatedDefinition.id && fault.id !== updatedDefinition.ts_fault_id) return fault

        const isEN_Tech = updatedDefinition.languageCode === 'EN' && updatedDefinition.userGroupId === 1

        return {
          ...fault,
          ...(isEN_Tech && updatedDefinition.descriptions?.length ? { descriptions: [...updatedDefinition.descriptions] } : {}),
        }
      })

      return {
        ...state,
        faultDetails: {
          ...state.faultDetails,
          definitions: state.faultDetails.definitions.map((def) => (def.id === updatedDefinition.definitionId ? { ...def, ...updatedDefinition } : def)),
        },
        faultsUpload: updatedFaultUpload,
        successMessage: i18n.t('troubleshoot.fault_updated_successfully'),
        isLoading: false,
      }
    case POST_FAULT_DEFINITION_FULFILLED:
      const newDefinition = Array.isArray(action.payload) ? action.payload[0] : action.payload

      return {
        ...state,
        faultDetails: {
          ...state.faultDetails,
          definitions: [...(state.faultDetails?.definitions || []), newDefinition],
        },
        successMessage: i18n.t('troubleshoot.fault_updated_successfully'),
        isLoading: false,
      }
    case DELETE_FAULT_FULFILLED:
      const remainingFaults = state?.faultsUpload.filter((item) => item.id !== action.meta.id)

      return {
        ...state,
        faultsUpload: remainingFaults,
        isLoading: false,
        successMessage: i18n.t('troubleshoot.fault_deleted_successfully'),
      }
    case DELETE_FAULT_DEFINITION_FULFILLED:
      const { definitionId } = action.meta
      const updatedDefinitions = state?.faultDetails.definitions.filter((def) => def.id !== definitionId)
      const deletedDef = state.faultDetails.definitions.find((def) => def.id === definitionId)
      const deletedLang = deletedDef?.languageCode
      const faultId = state.faultDetails.id

      const remainingLangDefs = updatedDefinitions.filter((d) => d.languageCode === deletedLang)

      const updatedFaultsUploads = state.faultsUpload.map((fault) => {
        if (fault.id !== faultId) return fault

        const updatedLanguageCodes = remainingLangDefs.length === 0 ? fault.languageCodes.filter((code) => code !== deletedLang) : fault.languageCodes

        return {
          ...fault,
          languageCodes: updatedLanguageCodes,
        }
      })

      return {
        ...state,
        faultDetails: {
          ...state.faultDetails,
          definitions: updatedDefinitions,
        },
        faultsUpload: updatedFaultsUploads,
        isLoading: false,
        successMessage: i18n.t('troubleshoot.fault_deleted_successfully'),
      }
    case CLEAR_TROUBLESHOOTING_MESSAGES: {
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      }
    }
    case CLEAR_FAULT_DETAILS: {
      return {
        ...state,
        faultDetails: null,
      }
    }
    default:
      return state
  }
}

